/* ============================================================================
   Custom Membership FAQ Accordion Script
   ============================================================================ */

document.addEventListener('DOMContentLoaded', () => {
  initFaqAccordion();
});

// Re-init on Shopify theme customizer block edit changes
document.addEventListener('shopify:section:load', () => {
  initFaqAccordion();
});

function initFaqAccordion() {
  const faqSections = document.querySelectorAll('.membership-faq');
  faqSections.forEach(section => {
    // Avoid double initialization
    if (section.classList.contains('initialized')) return;
    section.classList.add('initialized');

    const items = section.querySelectorAll('.membership-faq__item');
    const openFirst = section.getAttribute('data-open-first') === 'true';

    items.forEach((item, index) => {
      const button = item.querySelector('.membership-faq__question-button');
      const wrapper = item.querySelector('.membership-faq__answer-wrapper');
      
      if (!button || !wrapper) return;

      // Click event to toggle accordion item
      button.addEventListener('click', () => {
        const isOpen = item.classList.contains('is-open');
        
        // Close other items (accordion behavior)
        items.forEach(otherItem => {
          if (otherItem !== item && otherItem.classList.contains('is-open')) {
            otherItem.classList.remove('is-open');
            const otherBtn = otherItem.querySelector('.membership-faq__question-button');
            const otherWrapper = otherItem.querySelector('.membership-faq__answer-wrapper');
            if (otherBtn) otherBtn.setAttribute('aria-expanded', 'false');
            if (otherWrapper) otherWrapper.style.height = '0';
          }
        });

        // Toggle current item
        if (isOpen) {
          item.classList.remove('is-open');
          button.setAttribute('aria-expanded', 'false');
          wrapper.style.height = '0';
        } else {
          item.classList.add('is-open');
          button.setAttribute('aria-expanded', 'true');
          wrapper.style.height = wrapper.scrollHeight + 'px';
        }
      });

      // Expand first item on load if option is enabled
      if (index === 0 && openFirst) {
        item.classList.add('is-open');
        button.setAttribute('aria-expanded', 'true');
        // Delay to allow DOM container to resolve height limits
        setTimeout(() => {
          wrapper.style.height = wrapper.scrollHeight + 'px';
        }, 100);
      }
    });

    // Handle height recalculations on screen resizing
    window.addEventListener('resize', () => {
      items.forEach(item => {
        if (item.classList.contains('is-open')) {
          const wrapper = item.querySelector('.membership-faq__answer-wrapper');
          if (wrapper) wrapper.style.height = wrapper.scrollHeight + 'px';
        }
      });
    });
  });
}
